export const SEARCH_BASE_URL = '/api/onesearch';
